import React from 'react'
import _ from 'lodash'
import * as StyledComponent from '../styles'
import ColorSwatch from './ColorSwatch'

const ColorOptionLabel = (props, context) => {
  const showColorSwatch = props.swatch || !_.isEqual(props.hex_value.toLowerCase(), 'no_hex')
  return <StyledComponent.ColorOptionLabel className='color-option-label label' showColorSwatch={showColorSwatch}>
    {showColorSwatch && <ColorSwatch swatch={props.swatch} hex_value={props.hex_value} />}
    <span className='shadetext'>{props.name}</span>
</StyledComponent.ColorOptionLabel>

}

export default ColorOptionLabel



// WEBPACK FOOTER //
// ./src/components/ColorOptionLabel.js